import * as React from "react";
import * as recordService from "../../../models/services/recordService";
import { Dialog } from "../../framework/Dialog/Dialog";
import { Translations } from "ui/Scripts/source/models/translations";
import { List } from "../../framework/List/List";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { RecordExpiredFurtherEducationsList } from "../RecordExpiredFurtherEducationsList";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";

export interface IRecordArchiveExpiredFurtherEducationsDialogProps {
    classes?: string;
    companyId: string;
    onOk: () => void;
    onCancel: () => void;
}

export interface IRecordArchiveExpiredFurtherEducationsDialogState {
    selectedId: string;
    checkedIds: string[];
}

export class RecordArchiveExpiredFurtherEducationsDialog extends React.Component<IRecordArchiveExpiredFurtherEducationsDialogProps, IRecordArchiveExpiredFurtherEducationsDialogState> {
    constructor(props: IRecordArchiveExpiredFurtherEducationsDialogProps) {
        super(props);
        this.state = {
            selectedId: null,
            checkedIds: [],
        };
    }

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setState({
            selectedId,
            checkedIds
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    static getSaveData = (companyId: string, recordUserFurtherEducationIds: string[]): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("ids", recordUserFurtherEducationIds);
        result.append("companyId", companyId);
        return result;
    };

    static archiveRecordUserFurtherEducations = async (companyId: string, recordUserFurtherEducationIds: string[]): Promise<SaveSuccess> => {
        if (recordUserFurtherEducationIds.length < 1) return;
        const saveData = RecordArchiveExpiredFurtherEducationsDialog.getSaveData(companyId, recordUserFurtherEducationIds);
        // Call server
        return await AppUtils.callService(() => recordService.archiveRecordUserFurtherEducations(saveData.obj));
    };

    handleOk = async () => {
        const state = this.state;
        const result = await RecordArchiveExpiredFurtherEducationsDialog.archiveRecordUserFurtherEducations(this.props.companyId, List.getSelectedIds(state.selectedId, state.checkedIds));
        if (!result) return null;
        this.props.onOk();
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="record-archive-expired-further-education-dialog"
                maxWidth="lg"
                maxHeight="90%"
                title={Translations.ArchiveExpiredFurtherEducations}
                body={
                    <RecordExpiredFurtherEducationsList
                        companyId={props.companyId}
                        isReport={false}
                        employeeTypes={[]}
                        jobTitles={[]}
                        unitIds={[]}
                        activityState={0}
                        selectedId={state.selectedId}
                        checkedIds={state.checkedIds}
                        onSetSelectedIds={this.handleSetSelectedIds}
                    />
                }
                buttons={[
                    { title: Translations.Close, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.Archive, variant: "confirmation", onClick: this.handleOk },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}